import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/lib/Col';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cs from '../../components/commonStyle.css';
import { MessageSquare, Star, Anchor, ChevronRight } from 'lucide-react';

import Link from '../Link';
import UnreadMessages from './UnreadMessages';

import UnreadThreadsQuery from './getUnreadThreads.graphql';
import messages from '../../locale/messages';

import DashboardSideMenu from './DashboardSideMenu';

import s from './Dashboard.css';
class Dashboard extends React.Component {


  static propTypes = {
    formatMessage: PropTypes.any,
    account: PropTypes.shape({
      userId: PropTypes.string.isRequired,
      picture: PropTypes.string,
    }).isRequired,
    allUnreadThreads: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getUnreadThreads: PropTypes.array
    }),
    siteName: PropTypes.string.isRequired
  };

  static defaultProps = {
    allUnreadThreads: {
      loading: true,
      getUnreadThreads: []
    },
    account: {
      userId: null,
      picture: null
    }
  }

  render() {
    const { account: { userId, picture, firstName }, siteName } = this.props;
    const { allUnreadThreads: { loading, getUnreadThreads } } = this.props;
    const { formatMessage } = this.props.intl;
    let newMessages = 0;
    if (!loading) {
      newMessages = getUnreadThreads != null ? getUnreadThreads.length : 0;
    }
    let messageCount = formatMessage(messages.messages) + ` (${newMessages} ` + formatMessage(messages.messagesNew) + ')';

    return (
      <>
        <Col xs={12} sm={12} md={4} lg={4} className={cs.spaceTop6}>
          <DashboardSideMenu isDashboardPage />
        </Col>
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
          <div className={cx(s.welcomeCard, cs.spaceBottom3)}>
            <div>
              {firstName && <h3 className={s.welcomeTitle}>{formatMessage(messages.dashBoardHeader1) + ', ' + firstName}</h3>}
              <p className={s.welcomeText}>
                <FormattedMessage {...messages.dashBoardInfo} />
              </p>
            </div>
            <div className={s.welcomeEmoji}>👋</div>
          </div>
          <div className={cx(s.btnMainGrid, cs.spaceBottom6)}>
            <Link to={'/inbox'} className={cx(cs.textDecorationNone, s.actionCard)}>
              <MessageSquare className={s.actionIcon} />
              <div className={s.actionCardBottom}>
                <h4 className={s.actionCardTitle}><FormattedMessage {...messages.allMessages} /></h4>
                <ChevronRight className={s.actionArrow} />
              </div>
            </Link>
            <Link to={'/user/reviews/about-you'} className={cx(cs.textDecorationNone, s.actionCard)}>
              <Star className={s.actionIcon} />
              <div className={s.actionCardBottom}>
                <h4 className={s.actionCardTitle}><FormattedMessage {...messages.reviews} /></h4>
                <ChevronRight className={s.actionArrow} />
              </div>
            </Link>
            <Link to={'/boats'} className={cx(cs.textDecorationNone, s.actionCard)}>
              <Anchor className={s.actionIcon} />
              <div className={s.actionCardBottom}>
                <h4 className={s.actionCardTitle}><FormattedMessage {...messages.yourLists} /></h4>
                <ChevronRight className={s.actionArrow} />
              </div>
            </Link>
          </div>
          <div className={s.messagesCard}>
            <h4 className={s.messagesTitle}>{messageCount}</h4>
            <UnreadMessages
              userId={userId}
              loading={loading}
              getUnreadThreads={getUnreadThreads}
            />
          </div>
        </Col>
      </>
    );
  }
}

const mapState = (state) => ({
  account: state.account.data,
  siteName: state.siteSettings.data.siteName
});

const mapDispatch = {
};

export default compose(
  injectIntl,
  withStyles(s, cs),
  connect(mapState, mapDispatch),
  graphql(UnreadThreadsQuery, {
    name: 'allUnreadThreads',
    options: {
      ssr: false,
      pollInterval: 60000,
      fetchPolicy: 'network-only'
    }
  })
)(Dashboard);